import { PARENT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { safeGetValue } from '../../../../utils/index.tsx';
import { PARENT_FIELD_GQL_TYPE } from '../constants.tsx';
import type {
	jiraBusinessParentFieldFragment,
	jiraBusinessParentFieldFragment_parentIssue_fields_JiraIssueTypeField_issueType as IssueType,
} from '../fragment/__generated_apollo__/jiraBusinessParentFieldFragment.ts';
import type { TransformedParentField } from '../types.tsx';
import type { ParentTransformersMapping } from './types.tsx';

export const transformParentField = (): ParentTransformersMapping => ({
	[PARENT_FIELD_GQL_TYPE]: (
		field: jiraBusinessParentFieldFragment,
	): TransformedParentField | null => {
		if (field.__typename !== PARENT_FIELD_GQL_TYPE) {
			return null;
		}

		let fields = {};

		if (Array.isArray(field.parentIssue?.fields)) {
			const issueType = safeGetValue<IssueType | null>(
				field.parentIssue.fields,
				'issuetype',
				'issueType',
				null,
			);

			const color = safeGetValue<string | null>(
				field.parentIssue.fields,
				'issuecolor',
				'color.colorKey',
				null,
			);
			fields = {
				summary: safeGetValue(field.parentIssue.fields, 'summary', 'text', null),
				statusCategoryId: safeGetValue(
					field.parentIssue?.fields,
					'status',
					'status.statusCategory.statusCategoryId',
					null,
				),
				issueType: issueType
					? {
							name: issueType.name,
							iconUrl: issueType.avatar?.medium,
						}
					: null,
				color: color != null ? color.toUpperCase() : null,
			};
		}

		if (Array.isArray(field.parentIssue?.rankField)) {
			const rank = safeGetValue<string | null>(field.parentIssue?.rankField, 'rank', 'text', null);

			fields = { ...fields, rank: rank ?? null };
		}

		return {
			type: PARENT_TYPE,
			fieldId: field.fieldId,
			value: field.parentIssue
				? {
						id: field.parentIssue?.id,
						issueId: field.parentIssue?.issueId,
						issueKey: field.parentIssue?.key,
						...fields,
					}
				: null,
		};
	},
});
